<p>{{'preview-description' | pylPipe: isEmployeePlan : relationshipStatus}}</p>
<hr>

<h2 class="ey-heading">Your plan preview</h2>
<ng-container *ngIf="insuranceCoverage; else loader">

  <eync-pyl-preview-assessment [insuranceCoverage]="insuranceCoverage"
                               [isEmployeePlan]="isEmployeePlan"
                               [relationshipStatus]="relationshipStatus"
                               [showTip]="true"></eync-pyl-preview-assessment>

  <eync-pyl-summary-chart [insuranceCoverage]="insuranceCoverage"></eync-pyl-summary-chart>

  <eync-pyl-preview-variables [form]="form"></eync-pyl-preview-variables>
</ng-container>

<ng-template #loader>
  <div [ey-loader]="'graphic'" [loading]="true" style="height: 100px"></div>
</ng-template>
